import { Alert } from '@mui/material';
import { useNavigate, useParams } from 'react-router';
import { useOrganizations } from 'src/@nicheaim/fhir-react';
import Label from 'src/components/Label';
import DataTable, { DataTableColumn } from 'src/components/table/DataTable';
import fhirSystem from 'src/fhir/system';
import ClientsToolbar from './LOBsToolbar';

const columns: DataTableColumn[] = [
  {
    header: 'LOB Name',
    field: 'name',
  },
  {
    header: 'Status',
    field: 'active',
    render(active = true) {
      return <Label color={active ? 'success' : 'info'}>{active ? 'Active' : 'Inactive'}</Label>;
    },
  },
];

export default function LOBsTable() {
  const navigate = useNavigate();
  const { plan = '' } = useParams();
  const [lobs] = useOrganizations({
    filter: {
      identifier: fhirSystem.lineOfBusiness.withId(plan).forCode(''),
    },
  });

  return (
    <div>
      <ClientsToolbar />

      {lobs.length ? (
        <DataTable
          selectable
          clickeable
          columns={columns}
          data={lobs}
          onItemEdit={(item) => navigate(`${item.id}/edit`)}
          onItemClick={(item) => {
            if (item.id) {
              navigate(item.id);
            }
          }}
          sx={{ m: 2 }}
        />
      ) : (
        <Alert severity="info" sx={{ m: 2 }}>
          No lines of business found
        </Alert>
      )}
    </div>
  );
}
